import type { ParsedSeatData } from '../models/types';

export type WorldBounds = {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
};

export const WORLD_PADDING = 64;

export const buildWorldBounds = (
  parsedSeats: ParsedSeatData[],
  fallbackWidth: number,
  fallbackHeight: number
): WorldBounds => {
  if (parsedSeats.length === 0) {
    return {
      minX: 0,
      minY: 0,
      maxX: fallbackWidth,
      maxY: fallbackHeight,
    };
  }

  let minX = parsedSeats[0].x;
  let minY = parsedSeats[0].y;
  let maxX = parsedSeats[0].x;
  let maxY = parsedSeats[0].y;

  for (let index = 1; index < parsedSeats.length; index += 1) {
    const seat = parsedSeats[index];
    if (seat.x < minX) minX = seat.x;
    if (seat.y < minY) minY = seat.y;
    if (seat.x > maxX) maxX = seat.x;
    if (seat.y > maxY) maxY = seat.y;
  }

  return { minX, minY, maxX, maxY };
};

export const buildSeatCentroid = (
  parsedSeats: ParsedSeatData[],
  fallback: { x: number; y: number }
) => {
  if (parsedSeats.length === 0) return fallback;

  let sumX = 0;
  let sumY = 0;
  for (const seat of parsedSeats) {
    sumX += seat.x;
    sumY += seat.y;
  }

  return {
    x: sumX / parsedSeats.length,
    y: sumY / parsedSeats.length,
  };
};
